import { createActions } from 'redux-actions';

const actions = createActions({
  TASK: {
    CHOOSE_TASK_TYPE: (type) => ({ type }),
    API: {
      CHOOSE_TASK_TYPE: undefined
    }
  }
})

const configuration = {
  name: 'chooseTaskType',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      createTask: {
        ...state.createTask,
        type: action.payload.type
      },
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/chooseTaskType.js